import { Button, Stack, Typography } from '@mui/material';
import PreviewIcon from '@mui/icons-material/Preview';
import CusPopover from 'components/CusPopover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import DeleteIcon from '@mui/icons-material/Delete';
import { SETTING_TYPE } from 'pages/module/constant';
import { SETTING_ROW_STATUS } from 'utils/constant';
import { CheckCircle, MinusCircle, PlusCircle, RefreshCw, Trash2, XCircle } from 'react-feather';
import { toDefaultDateFormat } from 'utils/common';

export const returnStatusIcon = (status) => {
  switch (status) {
    case SETTING_ROW_STATUS.NOCHANGE:
      // return <Update />
      return <CheckCircle />;
    case SETTING_ROW_STATUS.UPDATED:
      // return <Update />
      return <RefreshCw />;
    case SETTING_ROW_STATUS.INSERTED:
      // return <Update />
      return <PlusCircle />;

    case SETTING_ROW_STATUS.ERROR:
      // return <HighlightOff />
      return <XCircle />;
    case SETTING_ROW_STATUS.DISABLED:
      // return <HighlightOff />
      return <MinusCircle />;

    default:
      return <></>;
  }
};

export const settingColumns = ({ t, openSiderbar, rifdList, currentSettingType, handleEdit, forImport, handleDisable, openAuditLogs }) => {
  const sharedColumns = !forImport
    ? [
        {
          headerName: t('ACTIVATE'),
          field: 'IsEnable',
          width: 100,
          renderCell: ({ row }) => <Typography>{row?.IsEnable === 'Y' ? t('YES') : t('NO')}</Typography>
        },
        { headerName: t('SORT'), field: 'Sort', width: 100 }
      ]
    : [
        {
          headerName: t('ACTIVATE'),
          field: 'IsEnable',
          width: 100,
          renderCell: ({ row }) => <Typography>{row?.IsEnable === 'Y' ? t('YES') : t('NO')}</Typography>
        },

        { headerName: t('SORT'), field: 'Sort', width: 100 }
      ];

  const editActionColumn = [
    {
      headerName: '',
      field: 'Edit',
      width: 100,
      renderCell: ({ row }) => (
        <Button
          onClick={() => {
            handleEdit(row);
          }}
          variant="outlined"
          startIcon={<PreviewIcon />}
        >
          {t('EDIT')}
        </Button>
      )
    }
  ];

  const actionColumn = forImport
    ? []
    : [
        {
          headerName: '',
          field: 'Action',
          width: 100,
          renderCell: ({ row }) => (
            <>
              <CusPopover shouldClose={openSiderbar || openAuditLogs} content={<MoreVertIcon />} id={`${row.stepCode}-popover`}>
                <Stack spacing={1}>
                  <Button
                    onClick={() => {
                      handleEdit(row);
                    }}
                    variant="outlined"
                    startIcon={<PreviewIcon />}
                  >
                    {t('EDIT')}
                  </Button>
                  <Button
                    onClick={() => {
                      handleDisable(row);
                    }}
                    variant="outlined"
                    startIcon={<DeleteIcon />}
                  >
                    {t('DISABLE')}
                  </Button>
                  <Button
                    onClick={() => {
                      openAuditLogs(row);
                    }}
                    variant="outlined"
                    startIcon={<MenuBookIcon />}
                  >
                    {t('AUDIT_TRAIL')}
                  </Button>
                </Stack>
              </CusPopover>
            </>
          )
        }
      ];

  const isDefaultColumn = {
    headerName: t('ISDEFAULT'),
    field: 'IsDefault',
    width: 100,
    renderCell: ({ row }) => <Typography>{row?.IsDefault === 'Y' ? t('YES') : t('NO')}</Typography>
  };

  const statusColumn = forImport
    ? [
        {
          headerName: t('STATUS'),
          field: 'RowStatus',
          width: 200,
          renderCell: ({ row }) => <Typography>{returnStatusIcon(row?.RowStatus)}</Typography>
        }
      ]
    : [];

  switch (currentSettingType) {
    case SETTING_TYPE.CATEGORY:
    case SETTING_TYPE.SUBCATEGORY:
      return [
        ...actionColumn,
        ...statusColumn,
        {
          headerName: t('BC_TYPE'),
          field: 'Bctype',
          width: 150
        },
        {
          headerName: t('CATEGORY'),
          field: 'Category',
          width: 200
        },
        {
          headerName: t('DESC'),
          field: 'DescEN',
          width: 200
        },
        {
          headerName: t('DESC_TC'),
          field: 'DescTC',
          width: 200
        },
        {
          headerName: t('DESC_SC'),
          field: 'DescSC',
          width: 200
        },
        isDefaultColumn,
        ...sharedColumns
      ];
    case SETTING_TYPE.COMPANY:
      return [
        ...actionColumn,
        ...statusColumn,
        {
          headerName: t('TYPE'),
          field: 'Type',
          width: 150
        },
        {
          headerName: t('BC_TYPE'),
          field: 'BCType',
          width: 150,
          renderCell: ({ row }) => <Typography>{row?.BCType === '*' ? t('ALL') : row?.BCType}</Typography>
        },
        {
          headerName: t('REFERENCE_CODE'),
          field: 'RefCode',
          width: 100
        },
        {
          headerName: t('NAME_EN'),
          field: 'NameEN',
          width: 200
        },
        {
          headerName: t('NAME_TC'),
          field: 'NameTC',
          width: 200
        },
        {
          headerName: t('NAME_SC'),
          field: 'NameSC',
          width: 200
        },
        {
          headerName: t('ADDRESS_EN'),
          field: 'AddressEN',
          width: 200
        },
        {
          headerName: t('ADDRESS_TC'),
          field: 'AddressTC',
          width: 200
        },
        {
          headerName: t('ADDRESS_SC'),
          field: 'AddressSC',
          width: 200
        },
        isDefaultColumn,
        ...sharedColumns
      ];
    case SETTING_TYPE.CONCRETE:
      return [
        ...actionColumn,
        ...statusColumn,
        {
          headerName: t('CONCRETE_GRADE'),
          field: 'Grade',
          width: 200
        },

        isDefaultColumn,
        ...sharedColumns
      ];
    case SETTING_TYPE.GPSHISTORY:
      return [
        ...editActionColumn,

        {
          headerName: t('RFID_TAG_NO'),
          field: 'RfidtagNo',
          width: 200
          // renderCell: ({ row }) => <Typography>{row?.LeftFactory === 'Y' ? t('YES') : t('NO')}</Typography>
        },
        {
          headerName: t('PRODUCT_NO'),
          field: 'ProductNo',
          width: 150
          // renderCell: ({ row }) => <Typography>{row?.LeftFactory === 'Y' ? t('YES') : t('NO')}</Typography>
        },
        {
          headerName: t('DEVICEID'),
          field: 'DeviceId',
          width: 150
        },
        {
          headerName: t('GPS_LAT'),
          field: 'GpsLat',
          width: 150
        },
        {
          headerName: t('GPS_LONG'),
          field: 'GpsLong',
          width: 150
        },
        {
          headerName: t('LEFTFACTORY'),
          field: 'LeftFactory',
          width: 100,
          renderCell: ({ row }) => <Typography>{row?.LeftFactory === 1 ? t('YES') : t('NO')}</Typography>
        },
        {
          headerName: t('ARRIVEDHK'),
          field: 'ArrivedHK',
          width: 100,
          renderCell: ({ row }) => <Typography>{row?.ArrivedHK === 1 ? t('YES') : t('NO')}</Typography>
        },
        {
          headerName: t('ARRIVEDSITE'),
          field: 'ArrivedSite',
          width: 100,
          renderCell: ({ row }) => <Typography>{row?.ArrivedSite === 1 ? t('YES') : t('NO')}</Typography>
        },
        {
          headerName: t('NOTIFIEDSITE'),
          field: 'NotifiedSite',
          width: 100,
          renderCell: ({ row }) => <Typography>{row?.NotifiedSite === 1 ? t('YES') : t('NO')}</Typography>
        },
        {
          headerName: t('CREATED_DATE'),
          field: 'CreatedDate',
          width: 200,
          renderCell: ({ row }) => <span>{toDefaultDateFormat(row?.CreatedDate, true)}</span>
        }
      ];
    case SETTING_TYPE.VEHICLE:
      return [
        ...editActionColumn,

        {
          headerName: t('LICENSE_PLATE_NO'),
          field: 'LicensePlateNo',
          width: 150
        },
        {
          headerName: t('GPS_DEVICE_ID'),
          field: 'GpsDeviceId',
          width: 200
        },

        // {
        //   headerName: t('CREATED_BY'),
        //   field: 'CreatedBy',
        //   width: 200
        // },
        {
          headerName: t('CREATED_DATE'),
          field: 'CreatedDate',
          width: 200,
          renderCell: ({ row }) => <span>{toDefaultDateFormat(row?.CreatedDate)}</span>
        }
        // {
        //   headerName: t('UPDATED_BY'),
        //   field: 'UpdatedBy',
        //   width: 200
        // },
        // {
        //   headerName: t('UPDATED_DATE'),
        //   field: 'UpdatedDate',
        //   width: 200,
        //   renderCell: ({ row }) => <span>{toDefaultDateFormat(row?.UpdatedDate)}</span>
        // }
      ];

    default:
      return [];
  }

  //   return [
  //     {
  //       headerName: t('BC_TYPE'),
  //       field: 'Bctype',
  //       width: 200
  //     },
  //     {
  //       headerName: t('DESC'),
  //       field: 'Desc',
  //       width: 200
  //     },
  //     {
  //       headerName: t('DESC_TC'),
  //       field: 'DescTc',
  //       width: 200
  //     },
  //     {
  //       headerName: t('DESC_SC'),
  //       field: 'DescSc',
  //       width: 200
  //     }
  //   ];
};
